import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
export const RefundPolicyPage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-6048">
      <Navbar data-id="element-6049" />

      {/* Main Content */}
      <div className="pt-20 pb-16" data-id="element-6050">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6051">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-6052">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6053">
              Refund Policy
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-6054">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6055">
                <strong data-id="element-6056">Last Updated:</strong> January 15, 2025
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6057">
                At Maestro Connect, we strive to provide a high-quality service.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6058">
                If you are not satisfied with your purchase, you may request a
                refund within 14 days of the initial purchase date.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6059">
                After 14 days, all payments are non-refundable.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6060">
                To request a refund, please contact us at{' '}
                <a href="mailto:support@maestroconnect.com" className="text-deep-pink hover:underline" data-id="element-6061">
                  support@maestroconnect.com
                </a>{' '}
                with your account details.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6062">
                We reserve the right to review refund requests to prevent abuse.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer data-id="element-6063" />
    </div>;
};